module.exports = __webpack_public_path__ + "img/image28.e1cb2c50.jpg";